import type { DeviceDetail } from "../../lib/api";
import { LteSection } from "./LteSection";
import { MwanCard } from "./MwanCard";
import { UplinksCard } from "./UplinksCard";

// Tab „Internet“ — die eine Antwort auf „wie kommt diese Box raus?“.
//
// Vorher war die Frage auf vier Tabs verteilt (LTE/WAN, Netzwerk, WLAN,
// WireGuard) und nirgends beantwortet. Hier stehen die Leitungen zuerst, das
// Modem als eine davon darunter. Der Mgmt-Tunnel gehört bewusst NICHT hierher:
// er läuft über den Uplink, er ist keiner (Tab „Fernzugriff“).
export function InternetSection({ device }: { device: DeviceDetail }) {
  return (
    <div className="flex flex-col gap-5">
      <UplinksCard device={device} />
      <LteSection device={device} />
      <MwanCard device={device} />
    </div>
  );
}
